import "./Faq.css";
import { useRef, useState } from 'react';
import {ReactComponent as PlusSign} from '../assets/plusSign.svg';
import {ReactComponent as MinusSign} from '../assets/minusSign.svg';
import {ReactComponent as BL} from '../assets/faq-bottom-left.svg';
import {ReactComponent as TL} from '../assets/faq-left.svg';
import {ReactComponent as R} from '../assets/faq-right.svg';
import { useTranslation } from 'react-i18next';

const Faq = () => {
  const { t } = useTranslation();
  // const lorem = "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Placeat voluptatibus autem id vero quas aspernatur maiores maxime facere ducimus! Assumenda obcaecati sunt laborum at numquam accusamus laboriosam odio reprehenderit voluptate.Adipisci voluptatem quidem labore quas fugiat quod non nobis expedita sed soluta dolorem optio officiis ullam, eum voluptas facere incidunt dignissimos at doloremque. Hic ea expedita in sint consectetur eius?Laboriosam recusandae veritatis beatae sapiente inventore dolor in ex praesentium unde accusantium temporibus minima ducimus libero est eum tempore earum optio, cumque fugit, tempora consequatur id, illo alias? Unde, atque"
  const titleContent = [{id: 1, title: t('faqQ1'), content: t('faqA1')}, 
  {id: 2,title: t('faqQ2'), content: t('faqA2')}, 
  {id: 3,title: t('faqQ3'), content: t('faqA3')},
  {id: 4,title: t('faqQ4'), content: t('faqA4')}]
  
  const faqs = titleContent.map(qs => false);
  const [openFaqs, setOpenFaqs] = useState<boolean[]>(faqs);
  const accordion: any = useRef(null);

  const getMap = () => {
    if (!accordion.current){
      accordion.current = new Map();
    }
    return accordion.current;
  }
  const toggleActive = (id: number) => {
    const map = getMap();
    map.get(id).classList.toggle("active");
    const newFaqsState = openFaqs.map((state, idx) => idx === id-1 ? !state : state);
    setOpenFaqs(newFaqsState);
  }
  return (
    <div className="faq" id="faq">
      <BL className="faq__bottom-left"></BL>
      <TL className="faq__top-left"></TL>
      <R className="faq__right"></R>
      <div className="title">
        {t('faqTitle')}
      </div>
      <div className="accordion">
        {titleContent.map((item, _) => (
          <div className="accordion__item" key={item.id}>
            <button className="accordion__item__title" onClick={ () => toggleActive(item.id)}>
              {item.title}
              {openFaqs[item.id-1] ?  <span className="minus__sign__container"><MinusSign className="accordion__item__sign" /></span> : <PlusSign className="accordion__item__sign" />}
            </button>
            <div className="accordion__item__content"
                      ref={(node) => {
                        const map = getMap();
                        if (node) {
                          map.set(item.id, node)
                        } else {
                          map.delete(item.id);
                        }
                      }}
            >
              <div>{item.content}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Faq